import {
  GET_REFER_FRIEND_FEATURE,
  GET_REFER_FRIEND_FEATURE_FAILED,
  GET_REFER_FRIEND_FEATURE_SUCCESS,
  GET_REFER_FRIEND_REPORTS_SUCCESS,
  RESET_REFER_FRIEND_FEATURE_FORM,
  RESET_REFER_FRIEND_REPORTS,
} from "./actionTypes"

const INIT_STATE = {
  referFriend: null,
  referFriendReport: null,
  loading: false,
}

const ReferFriend = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REFER_FRIEND_FEATURE:
      return {
        ...state,
        loading: true,
      }
    case GET_REFER_FRIEND_FEATURE_FAILED:
      return {
        ...state,
        loading: false,
      }
    case GET_REFER_FRIEND_FEATURE_SUCCESS:
      return {
        ...state,
        referFriend: action.payload,
        loading: false,
      }
    case RESET_REFER_FRIEND_FEATURE_FORM:
      return {
        ...state,
        referFriend: null,
      }
    case GET_REFER_FRIEND_REPORTS_SUCCESS:
      return {
        ...state,
        referFriendReport: action.payload,
      }
    case RESET_REFER_FRIEND_REPORTS:
      return {
        ...state,
        referFriendReport: null,
      }
    default:
      return state
  }
}

export default ReferFriend
